"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tickerExternalAgentActionsQuery = exports.tickerExternalAgentHistoryQuery = exports.tickerExternalAgentsQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 * @hidden
 *
 * Get the event details when external agent added for a ticker
 */
function tickerExternalAgentsQuery(paddedIds, variables) {
    const orderBy = paddedIds
        ? `${types_1.TickerExternalAgentsOrderBy.CreatedBlockIdDesc}`
        : `${types_1.TickerExternalAgentsOrderBy.CreatedAtDesc}, ${types_1.TickerExternalAgentsOrderBy.CreatedBlockIdDesc}`;
    const query = (0, graphql_tag_1.default) `
    query TickerExternalAgentQuery($assetId: String!) {
      tickerExternalAgents(
        filter: { assetId: { equalTo: $assetId } }
        orderBy: [${orderBy}]
        first: 1
      ) {
        nodes {
          eventIdx
          createdBlock {
            blockId
            datetime
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.tickerExternalAgentsQuery = tickerExternalAgentsQuery;
/**
 * @hidden
 *
 * Get the transaction history of each external agent of an Asset
 */
function tickerExternalAgentHistoryQuery(paddedIds, variables) {
    const orderBy = paddedIds
        ? `${types_1.TickerExternalAgentHistoriesOrderBy.CreatedBlockIdAsc}`
        : `${types_1.TickerExternalAgentHistoriesOrderBy.CreatedAtAsc}, ${types_1.TickerExternalAgentHistoriesOrderBy.CreatedBlockIdAsc}`;
    const query = (0, graphql_tag_1.default) `
    query TickerExternalAgentHistoryQuery($assetId: String!) {
      tickerExternalAgentHistories(
        filter: { assetId: { equalTo: $assetId } }
        orderBy: [${orderBy}]
      ) {
        nodes {
          identityId
          eventIdx
          createdBlock {
            blockId
            hash
            datetime
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.tickerExternalAgentHistoryQuery = tickerExternalAgentHistoryQuery;
/**
 * @hidden
 *
 * Get list of Events triggered by actions (from the set of actions that can only be performed by external agents) that have been performed on a specific Asset
 */
function tickerExternalAgentActionsQuery(paddedIds, filters, size, start) {
    const { args, filter } = (0, common_1.createArgsAndFilters)(filters, { eventId: 'EventIdEnum' });
    const orderBy = paddedIds
        ? `${types_1.TickerExternalAgentActionsOrderBy.CreatedBlockIdDesc}`
        : `${types_1.TickerExternalAgentActionsOrderBy.CreatedAtDesc}, ${types_1.TickerExternalAgentActionsOrderBy.CreatedBlockIdDesc}`;
    const query = (0, graphql_tag_1.default) `
    query TickerExternalAgentActionsQuery
      ${args}
     {
      tickerExternalAgentActions(
        ${filter}
        first: $size
        offset: $start
        orderBy: [${orderBy}]
      ) {
        totalCount
        nodes {
          eventIdx
          palletName
          eventId
          callerId
          createdBlock {
            blockId
            datetime
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.tickerExternalAgentActionsQuery = tickerExternalAgentActionsQuery;
//# sourceMappingURL=externalAgents.js.map